import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const Message = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 100px;
`;



const TraccWebMapPurchase = () => 
(<Container>
    <Message>
        <p>Your purchase of the TRACC MapShare was successful.</p> 
        <p>You can now return to TRACC and start using it straight away.</p>
        <p>Visit <a href="/management/orders">Orders</a> to see order details and invoice.</p>

        </Message>
</Container>);
export default TraccWebMapPurchase;